import { render, staticRenderFns } from "./sidebar-flugplanung-inlandsfluege.vue?vue&type=template&id=64898ed7&scoped=true"
import script from "./sidebar-flugplanung-inlandsfluege.vue?vue&type=script&lang=js"
export * from "./sidebar-flugplanung-inlandsfluege.vue?vue&type=script&lang=js"
import style0 from "./sidebar-flugplanung-inlandsfluege.vue?vue&type=style&index=0&id=64898ed7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64898ed7",
  null
  
)

export default component.exports